import { useCallback, useState } from "react";

import { useClipboard } from "@chakra-ui/react";

import { toastSuccess } from "@/util/helpers";

interface UseCopyToClipboardOptions {
  text: string;
  showToast?: boolean;
  showTooltip?: boolean;
  tooltipDuration?: number;
}

export const useCopyToClipboard = ({
  text,
  showToast = false,
  showTooltip = false,
  tooltipDuration = 1200
}: UseCopyToClipboardOptions) => {
  const { onCopy } = useClipboard(text);
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    onCopy();

    if (showToast) {
      toastSuccess("Copied!");
    }

    if (showTooltip) {
      setCopied(true);
      setTimeout(() => setCopied(false), tooltipDuration);
    }
  }, [onCopy, showToast, showTooltip, tooltipDuration]);

  return {
    handleCopy,
    copied
  };
};
